
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30300',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30300",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54606",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8024",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11482",
  "I18n": "static-7.1628",
  "quartz": "static-1.7047",
  "quartz-config": "static-1.825",
  "quartz-core": "static-1.6266",
  "react-dlb": "static-1.79",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.794",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54593",
  "feedback-utils": "static-1.54597",
  "forms-embed-utils-lib": "static-1.4474",
  "forms-utils-lib": "static-1.12608",
  "foundations-assets": "static-1.4877",
  "foundations-components": "static-1.7961",
  "foundations-theming": "static-1.4429",
  "hub-http": "static-1.6232",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11789",
  "icons": "static-2.648",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3923",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5351",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.487",
  "tinymce-plugins": "static-1.57524",
  "transmute": "static-2.85",
  "ui-images": "static-2.1156",
  "UIComponents": "static-3.8428",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3405",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3324",
  "quartz-webpack": "static-1.3271",
  "foundations-theming-specialty": "static-1.2145",
  "property-description-translator": "static-1.3855",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3135",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4338",
  "jasmine-runner": "static-1.6475",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4658",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.722",
  "quartz-head": "static-1.712",
  "quartz-i18n": "static-1.722",
  "quartz-routing": "static-1.477",
  "quartz-test": "static-1.722",
  "quartz-tracking": "static-1.426",
  "ui-fonts": "static-1.744",
  "usage-tracker-container": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.156",
  "conversations-skeleton-state": "static-1.7257",
  "reference-resolvers": "static-1.8181",
  "sanitize-text": "static-1.8152",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10376",
  "sanitize": "static-1.4487",
  "outpost": "static-1.4192",
  "rpc-client-utils": "static-1.4663",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4230",
  "floating-ui": "static-1.56",
  "hs-story-utils": "static-1.9435",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1979",
  "bend-plugin-foundations-theming": "static-1.2912",
  "foundations-theming-base": "static-1.3414",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.87",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "ai-components-ui-library": "static-1.9016",
  "atom": "static-1.5083",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7770",
  "ContentUtils": "static-1.68407",
  "data-token-picker": "static-1.16430",
  "file-manager-components": "static-1.23662",
  "FileManagerCore": "static-1.39161",
  "FileManagerLib": "static-1.39302",
  "frontend-preferences-client": "static-1.7938",
  "hub-http-contrib": "static-1.3053",
  "interframe": "static-3.4770",
  "layout-dnd-components": "static-1.12469",
  "layout-dnd-utils": "static-1.11444",
  "property-translator": "static-1.5411",
  "react-codemirror": "static-1.10637",
  "react-colorpicker": "static-2.10217",
  "reference-resolvers-lite": "static-1.8105",
  "rich-text-lib": "static-1.19856",
  "tinymce-data": "static-1.40495",
  "tinymce-themes": "static-1.56380",
  "ui-addon-emoji-picker": "static-1.9898",
  "ui-addon-sales-email": "static-1.5221",
  "ui-brand-identity-lib": "static-1.15327",
  "bender-build-tools": "static-1.3205",
  "hub-http-shared-msw-handlers": "static-1.9994",
  "hubspotter-http-shared-msw-handlers": "static-1.9992",
  "usage-tracker-session-replay": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.73",
  "chirp-fetch": "static-1.1898",
  "chatspot-core": "static-1.21393",
  "copilot-toolkit": "static-1.11169",
  "customer-data-objects-ui-components": "static-1.13038",
  "data-fetching-client": "static-1.9679",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4772",
  "ui-addon-video-player": "static-1.8713",
  "ui-coaching-tips": "static-1.28600",
  "usage-tracker": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "cms-field-types": "static-1.4823",
  "content-icons-ui": "static-1.2229",
  "integrations-lib": "static-1.16193",
  "customer-data-objects": "static-1.7680",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4662",
  "apollo-stack-hubspot": "static-3.86",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "immerable": "static-1.4165",
  "ui-addon-iframeable": "static-1.9068",
  "video-components-external": "static-1.11319",
  "video-data-lib": "static-1.34977",
  "audio-components": "static-1.5932",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29316",
  "FileManagerImages": "static-1.36813",
  "foundations-components-legacy": "static-1.986",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.525",
  "ui-universal-auth": "static-1.8991",
  "urlinator": "static-1.4547",
  "video-components": "static-1.13322",
  "video-embed": "static-1.35811",
  "ts-schema": "static-1.4086",
  "ContentData": "static-1.68482",
  "layout-data-lib": "static-1.9769",
  "react-dnd-compat": "static-1.4625",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1552",
  "external-options-client-types": "static-1.4165",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6895",
  "hs-promise-utils": "static-1.5602",
  "inbound-db-properties-service-client": "static-1.3852",
  "NamespacedHubStyle": "static-2.9065",
  "growth-onboarding-confetti": "static-1.3077",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11159",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5559",
  "magpie-types": "static-1.5019",
  "simple-logging-lib": "static-1.3061",
  "avatar-components": "static-1.2507",
  "customer-data-ui-utilities": "static-1.9837",
  "growth-onboarding-feedback-components": "static-1.6591",
  "flux-actions": "static-1.338",
  "hubspot-apollo-client": "static-1.4890",
  "integrations-error-boundary-lib": "static-1.13608",
  "integrations-tracking-lib": "static-1.5611",
  "laboratory-lib": "static-3.7166",
  "native-integrations-shared-strings": "static-1.7792",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10175",
  "unified-auth": "static-1.505",
  "navigation-messaging": "static-1.7403",
  "content-media-composition-data-lib": "static-1.12364",
  "content-media-compositions": "static-2.16371",
  "idb-keyval": "static-1.44",
  "media-bridge-lib": "static-1.18949",
  "unified-auth-core-lib": "static-1.787",
  "social-insights-client-types": "static-1.22155",
  "advanced-menus-core": "static-1.15146",
  "advanced-menus-lib": "static-1.12085",
  "ExportDialog": "static-6.10399",
  "ui-memberships-settings-lib": "static-1.34086",
  "conditional-properties-service-client": "static-1.3803",
  "crm-pipelines-api-client-types": "static-1.4145",
  "fdsr-migration-layer": "static-1.14",
  "framework-builder-read-service-client": "static-1.4011",
  "framework-data-schema-quick-fetch": "static-1.6800",
  "inbound-db-meta-service-client": "static-1.3592",
  "multi-currency-client-types": "static-1.3697",
  "persist-promise": "static-1.3709",
  "foundations-components-test-utils": "static-1.5444",
  "reactive-lib": "static-1.735",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.349",
  "universal-page-editor-lib": "static-1.3023",
  "google-sheets-integration-lib": "static-1.281",
  "microsoft-drive-integration-lib": "static-1.399",
  "slack-ui-library": "static-1.10403",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3741",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15145",
  "simple-menus-lib": "static-1.16662",
  "crm-record-cards-service-types": "static-1.3603",
  "location-customization-utils-lib": "static-1.9305",
  "react-flip-move": "static-1.70"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30300",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54606",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8024",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11482",
  "I18n": "/I18n/static-7.1628",
  "quartz": "/quartz/static-1.7047",
  "quartz-config": "/quartz-config/static-1.825",
  "quartz-core": "/quartz-core/static-1.6266",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.794",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54593",
  "feedback-utils": "/feedback-utils/static-1.54597",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4474",
  "forms-utils-lib": "/forms-utils-lib/static-1.12608",
  "foundations-assets": "/foundations-assets/static-1.4877",
  "foundations-components": "/foundations-components/static-1.7961",
  "foundations-theming": "/foundations-theming/static-1.4429",
  "hub-http": "/hub-http/static-1.6232",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11789",
  "icons": "/icons/static-2.648",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3923",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5351",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tinymce-plugins": "/tinymce-plugins/static-1.57524",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1156",
  "UIComponents": "/UIComponents/static-3.8428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3405",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3324",
  "quartz-webpack": "/quartz-webpack/static-1.3271",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2145",
  "property-description-translator": "/property-description-translator/static-1.3855",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3135",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4338",
  "jasmine-runner": "/jasmine-runner/static-1.6475",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4658",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.722",
  "quartz-head": "/quartz-head/static-1.712",
  "quartz-i18n": "/quartz-i18n/static-1.722",
  "quartz-routing": "/quartz-routing/static-1.477",
  "quartz-test": "/quartz-test/static-1.722",
  "quartz-tracking": "/quartz-tracking/static-1.426",
  "ui-fonts": "/ui-fonts/static-1.744",
  "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7257",
  "reference-resolvers": "/reference-resolvers/static-1.8181",
  "sanitize-text": "/sanitize-text/static-1.8152",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10376",
  "sanitize": "/sanitize/static-1.4487",
  "outpost": "/outpost/static-1.4192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4663",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4230",
  "floating-ui": "/floating-ui/static-1.56",
  "hs-story-utils": "/hs-story-utils/static-1.9435",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1979",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2912",
  "foundations-theming-base": "/foundations-theming-base/static-1.3414",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.87",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9016",
  "atom": "/atom/static-1.5083",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7770",
  "ContentUtils": "/ContentUtils/static-1.68407",
  "data-token-picker": "/data-token-picker/static-1.16430",
  "file-manager-components": "/file-manager-components/static-1.23662",
  "FileManagerCore": "/FileManagerCore/static-1.39161",
  "FileManagerLib": "/FileManagerLib/static-1.39302",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7938",
  "hub-http-contrib": "/hub-http-contrib/static-1.3053",
  "interframe": "/interframe/static-3.4770",
  "layout-dnd-components": "/layout-dnd-components/static-1.12469",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11444",
  "property-translator": "/property-translator/static-1.5411",
  "react-codemirror": "/react-codemirror/static-1.10637",
  "react-colorpicker": "/react-colorpicker/static-2.10217",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8105",
  "rich-text-lib": "/rich-text-lib/static-1.19856",
  "tinymce-data": "/tinymce-data/static-1.40495",
  "tinymce-themes": "/tinymce-themes/static-1.56380",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9898",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5221",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15327",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9994",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9992",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.73",
  "chirp-fetch": "/chirp-fetch/static-1.1898",
  "chatspot-core": "/chatspot-core/static-1.21393",
  "copilot-toolkit": "/copilot-toolkit/static-1.11169",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13038",
  "data-fetching-client": "/data-fetching-client/static-1.9679",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4772",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8713",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28600",
  "usage-tracker": "/usage-tracker/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "cms-field-types": "/cms-field-types/static-1.4823",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "integrations-lib": "/integrations-lib/static-1.16193",
  "customer-data-objects": "/customer-data-objects/static-1.7680",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4662",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4165",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9068",
  "video-components-external": "/video-components-external/static-1.11319",
  "video-data-lib": "/video-data-lib/static-1.34977",
  "audio-components": "/audio-components/static-1.5932",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29316",
  "FileManagerImages": "/FileManagerImages/static-1.36813",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.986",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.525",
  "ui-universal-auth": "/ui-universal-auth/static-1.8991",
  "urlinator": "/urlinator/static-1.4547",
  "video-components": "/video-components/static-1.13322",
  "video-embed": "/video-embed/static-1.35811",
  "ts-schema": "/ts-schema/static-1.4086",
  "ContentData": "/ContentData/static-1.68482",
  "layout-data-lib": "/layout-data-lib/static-1.9769",
  "react-dnd-compat": "/react-dnd-compat/static-1.4625",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1552",
  "external-options-client-types": "/external-options-client-types/static-1.4165",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6895",
  "hs-promise-utils": "/hs-promise-utils/static-1.5602",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3852",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9065",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3077",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11159",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5559",
  "magpie-types": "/magpie-types/static-1.5019",
  "simple-logging-lib": "/simple-logging-lib/static-1.3061",
  "avatar-components": "/avatar-components/static-1.2507",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9837",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6591",
  "flux-actions": "/flux-actions/static-1.338",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4890",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13608",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5611",
  "laboratory-lib": "/laboratory-lib/static-3.7166",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7792",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10175",
  "unified-auth": "/unified-auth/static-1.505",
  "navigation-messaging": "/navigation-messaging/static-1.7403",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12364",
  "content-media-compositions": "/content-media-compositions/static-2.16371",
  "idb-keyval": "/idb-keyval/static-1.44",
  "media-bridge-lib": "/media-bridge-lib/static-1.18949",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.787",
  "social-insights-client-types": "/social-insights-client-types/static-1.22155",
  "advanced-menus-core": "/advanced-menus-core/static-1.15146",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12085",
  "ExportDialog": "/ExportDialog/static-6.10399",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34086",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3803",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4145",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.14",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4011",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6800",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3592",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3697",
  "persist-promise": "/persist-promise/static-1.3709",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5444",
  "reactive-lib": "/reactive-lib/static-1.735",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.349",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3023",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.281",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.399",
  "slack-ui-library": "/slack-ui-library/static-1.10403",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3741",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15145",
  "simple-menus-lib": "/simple-menus-lib/static-1.16662",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3603",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9305",
  "react-flip-move": "/react-flip-move/static-1.70"
}
};
